export const EM_DASH = '—';

export {};
